































































import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import { Affix } from 'vue-affix'
import { AdminUserRoutes } from '@/modules/user/routes/admin-user.route'
import { Prop } from 'vue-property-decorator'

@Component({
  components: {
    Affix
  }
})
export default class AdminUserShowSideNav extends Vue {

  constructor(
    private readonly routes: AdminUserRoutes) {
    super()
  }

  @Prop({ required: true }) userId: number

  scrollPageTo(navEl) {
    let element = document.querySelector(`#${navEl}`)
    element.scrollIntoView({ behavior: 'smooth', block: 'start' })
  }

}
